import { CurrencySetting, Point } from "../../type";

export type AnimationPoint = {
  x: number;
  y: number;
  isIceBreak: boolean;
  isDropdownPoint: boolean;
  groupId: number;
  endId: number;
  win: number;
};

export type VikingBlastGameData = {
  bombCount: number;
  animationPoints?: AnimationPoint[];
  triggeredFeatureSymbolId: FeatureSymbols;
  triggeredFeaturePoint?: Point;
  candyBaySymbolIds?: number[];
  rocketDirection: "None" | "Horizontal" | "Vertical";
  freeModeSymbolIds?: number[];
  freeSpinMultiplier: number;
};

export enum Symbols {
  RainbowGem = 201,
  Gold = 202,
  Amber = 203,
  Ruby = 204,
  Iolite = 101,
  VioletLollipop = 102,
  Sapphire = 103,
  Emerald = 104,
  Ship = 4,
  Axe = 3,
  Horn = 2,
  VikingBlast = 8,
  Scatter = 25,
}

export enum FeatureSymbols {
  None = 0,
  Ship = 4,
  Axe = 3,
  Horn = 2,
  ShipShip = 44,
  AxeAxe = 33,
  HornHorn = 22,
  ShipAxe = 43,
  ShipHorn = 42,
  AxeHorn = 32,
  VikingBlast = 8,
  Scatter = 25,
}

export type Rule = {
  buyFreeSpinRate: number;
  payouts: { [k: string]: number };
  givenFreeSpin: { [k: string]: number };
};

export type Setting = {
  currencies: CurrencySetting[];
  payouts: { [k: string]: number };
  buyFreeSpinRate: number;
};
